<template>
  <section>
    <div id="cameraList">
      <ul v-if="cameraInfo !== null && imgSrc.length !== 0">
          <li class="clearfix" :class="thumbnailSize" v-for="(list, key) in cameraInfo" :key="cameraInfo + key">
              <div class="list_header">
                  <h3 :id="'term-name_' + list.term_id">
                      <span v-if='imgSrc[key]["record_status"] === "1"' class="live">▶<span>ライブ</span></span>
                      <span v-else class="stop_live">■<span>停止中</span></span>
                      {{list.description}}
                  </h3>
              </div>
              <div class="list_body">
                  <div v-if='imgSrc[key]' class="photo" @click="clickMove(key, list.term_id)" :id="'photo_' + list.term_id">
                    <a href="javascript:;" :class="checkImgContent(key)"></a>
                    <img :src='imgSrc[key]["camera_latest_static_snapshot_url"] !== "" && imgSrc[key]["record_status"] === "1" ? imgSrc[key]["camera_latest_static_snapshot_url"] : noImageUrl' />
                  </div>
              </div>
          </li>
      </ul>
    </div>
  </section>
</template>
<script>
export default ({
  name: 'LiveLists',
  data: function(){
    return{
      // サムネイルを格納
      imgSrc: [],

      // 録画停止中または映像が取得できない場合にNoImageを表示
      noImageUrl: require("../../assets/images/no_image.png")
    }
  },
  props: {
    // 親コンポーネントより、現場情報を取得
    siteInfo:{
        type: Array
    },
    // 親コンポーネントより、端末情報を取得
    cameraInfo:{
        type: Array
    },
    // 親コンポーネントより、サムネイル画像情報などを取得
    imgUrlCamera:{
        type: Array
    },
    // 親コンポーネントより、サムネイル画像の表示サイズを保持するためのものを取得
    thumbnailSize:{
        type: String
    },
  },
  methods: {
    /**********************************************************/
    // サムネイル更新のための処理
    /**********************************************************/
    changeImgSrc() {
      this.imgSrc = this.imgUrlCamera
    },
    /**********************************************************/
    // サムネイルをクリックした時の処理
    // 親コンポーネントに、各引数と必要な情報を送る & モーダルを開く
    /**********************************************************/
    // 引数
    // key    : クリックしたサムネイルの時間
    // termId : クリックしたサムネイルの端末ID
    /**********************************************************/
    clickMove(key, termId) {
        // no imageの場合にモーダルを開かないように制御
        if (document.getElementById("photo_" + termId).getElementsByClassName('overlay-movie-icon').length === 1) {
          // 親コンポーネント関数に選択したサムネイル箇所と端末IDを引数にして実行
          this.$emit('modalOpen', { key:key, term_id:termId });
        }
    },
    /**********************************************************************/
    // 取得してくるサムネイル画像が存在しない場合に再生アイコンを非表示にする処理
    // no_image画像を取得した段階でcssを切り替える
    // [11/25追記]
    // サムネイルがあっても録画停止中の場合はNo Imageを出すように変更
    /**********************************************************************/
    // 引数
    // key    : クリックしたサムネイルの端末番号
    /**********************************************************/
    checkImgContent(key) {// eslint-disable-line
      var thumbnailImgCls = "overlay-movie-icon"
      if(this.imgSrc[key]["camera_latest_static_snapshot_url"] === "" || (this.imgSrc[key]["camera_latest_static_snapshot_url"] !== "" && this.imgSrc[key]["record_status"] === "0")){
        thumbnailImgCls = ""
      }
      return thumbnailImgCls
    }
  },
  watch: {
    /******************************************************************************/
    // サムネイル画像などを格納した配列に変化があったときに実行される処理
    /******************************************************************************/
    imgUrlCamera: {
      handler() {
        // ビュー全体がレンダリングされるまで待つ
        this.$nextTick(function () {
          var vm = this;
          vm.changeImgSrc();
        })
      },
      deep: true
    },
  },

})
</script>
<style lang="scss" scoped>
@import "../../assets/css/main/LiveLists.css";
</style>
